import { mutatorAction } from "satcheljs";
import { presenceStore } from "../store/presenceStore";
import { debugLog } from "../logging/debugLog";

export const setIsPresenceLicenseEnabledMutator: (isEnabled: boolean) => void = mutatorAction("setIsPresenceLicenseEnabled", (isEnabled: boolean): void => {
    debugLog("setIsPresenceLicenseEnabled", isEnabled);
    presenceStore().isLicenseEnabled = isEnabled;
});
